/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { v4 as uuidv4 } from 'uuid';

import { DeviceModel } from '../device/DeviceModel';

export class UniqueIdentifier {
    private static mRequestIdCounter: number = 0;

    private static networkCallId: number = 0;

    private static guidePreviewNetworkCallId: number = 0;

    private static oneLineGuideCellsNetworkCallId: number = 0;

    private static onePassManagerNetworkCallId: number = 0;

    private static onePassServiceNetworkCallId: number = 0;

    private static sessionNetworkCallId: number = 0;

    private static sessionStopNetworkCallId: number = 0;

    private static actionDetailsNetworkCallId: number = 0;

    private static actionsNetworkCallId: number = 0;

    private static actionsNetworkCallIdForLiveTv: number = 0;

    private static myShowsNetworkCallId: number = 0;

    private static mCollectionActionNetworkCallId: number = 0;

    private static mCollectionFilterNetworkCallId: number = 0;

    private static upcomingNetworkCallId: number = 0;

    private static sessionId: string = uuidv4();

    /**
     *
     * @returns {string} originRequestId
     * format - <timestamp>-<processId>-<deviceId>-<counter>
     */
    public static generateOriginRequestId = (): string => {
        const timestamp = new Date().getTime();
        const processId = 'p1234';
        const caDeviceId = DeviceModel.getCaDeviceId();
        UniqueIdentifier.mRequestIdCounter += 1;

        return `${timestamp}-${processId}-${caDeviceId}-${UniqueIdentifier.mRequestIdCounter}`;
    };

    /**
     *
     * @returns {string} x-amxn-requestId
     * format - <process id/ip address>-<service specific>-<counter>-<unix timestamp>
     */
    public static generateXAmznRequestId = (): string => {
        let processId = '';
        if (DeviceModel.getTVProperties().getIpAddress() !== 'Unknown') {
            processId = DeviceModel.getTVProperties().getIpAddress();
        } else if (DeviceModel.getTVProperties().getHsn() !== 'Unknown') {
            processId = DeviceModel.getTVProperties().getHsn();
        } else if (DeviceModel.getTVProperties().getMacAddress().length !== 0) {
            processId = DeviceModel.getTVProperties().getMacAddress();
        } else {
            processId = 'p1234';
        }
        UniqueIdentifier.mRequestIdCounter += 1;
        const timestamp = new Date().getTime();

        return `${processId}-${UniqueIdentifier.mRequestIdCounter}-${timestamp}`;
    };

    public static getNetworkCallId() {
        return this.networkCallId;
    }

    public static getNextNetworkCallId() {
        this.networkCallId += 1;
        return this.networkCallId;
    }

    public static getGuidePreviewNetworkCallId() {
        return this.guidePreviewNetworkCallId;
    }

    public static getNextGuidePreviewNetworkCallId() {
        this.guidePreviewNetworkCallId += 1;
        return this.guidePreviewNetworkCallId;
    }

    public static getOneLineGuideCellsNetworkCallId() {
        return this.oneLineGuideCellsNetworkCallId;
    }

    public static getNextOneLineGuideCellsNetworkCallId() {
        this.oneLineGuideCellsNetworkCallId += 1;
        return this.oneLineGuideCellsNetworkCallId;
    }

    public static getOnePassManagerNetworkCallId() {
        return this.onePassManagerNetworkCallId;
    }

    public static getNextOnePassManagerNetworkCallId() {
        this.onePassManagerNetworkCallId += 1;
        return this.onePassManagerNetworkCallId;
    }

    public static getOnePassServiceNetworkCallId() {
        return this.onePassServiceNetworkCallId;
    }

    public static getNextOnePassServiceNetworkCallId() {
        this.onePassServiceNetworkCallId += 1;
        return this.onePassServiceNetworkCallId;
    }

    public static getActionsNetworkCallId() {
        return this.actionsNetworkCallId;
    }

    public static getNextActionsNetworkCallId() {
        this.actionsNetworkCallId += 1;
        return this.actionsNetworkCallId;
    }

    public static getActionsNetworkCallIdForLiveTv() {
        return this.actionsNetworkCallIdForLiveTv;
    }

    public static getNextActionsNetworkCallIdForLiveTv() {
        this.actionsNetworkCallIdForLiveTv += 1;
        return this.actionsNetworkCallIdForLiveTv;
    }

    public static getSessionNetworkCallId() {
        return this.sessionNetworkCallId;
    }

    public static getNextSessionNetworkCallId() {
        this.sessionNetworkCallId += 1;
        return this.sessionNetworkCallId;
    }

    public static getSessionStopNetworkCallId() {
        return this.sessionStopNetworkCallId;
    }

    public static getNextSessionStopNetworkCallId() {
        this.sessionStopNetworkCallId += 1;
        return this.sessionStopNetworkCallId;
    }

    public static getOttActionDetailsNetworkCallId() {
        return this.actionDetailsNetworkCallId;
    }

    public static getNextOttActionDetailsNetworkCallId() {
        this.actionDetailsNetworkCallId += 1;
        return this.actionDetailsNetworkCallId;
    }

    public static getNextMyShowsNetworkCallId() {
        this.myShowsNetworkCallId += 1;
        return this.myShowsNetworkCallId;
    }

    public static getMyShowsNetworkCallId() {
        return this.myShowsNetworkCallId;
    }

    public static getNextCollectionActionNetworkCallId() {
        this.mCollectionActionNetworkCallId += 1;
        return this.mCollectionActionNetworkCallId;
    }

    public static getCollectionActionNetworkCallId() {
        return this.mCollectionActionNetworkCallId;
    }

    public static getNextCollectionFilterNetworkCallId() {
        this.mCollectionFilterNetworkCallId += 1;
        return this.mCollectionFilterNetworkCallId;
    }

    public static getCollectionFilterNetworkCallId() {
        return this.mCollectionFilterNetworkCallId;
    }

    public static getNextUpcomingNetworkCallId() {
        this.upcomingNetworkCallId += 1;
        return this.upcomingNetworkCallId;
    }

    public static getUpcomingNetworkCallId() {
        return this.upcomingNetworkCallId;
    }

    public static uuid4(): string {
        return uuidv4();
    }

    public static getSessionId() {
        return UniqueIdentifier.sessionId;
    }
}
